import styled from "styled-components";

import { colours } from "../../styles/colours.constants";
import { satoshi500 } from "../../styles/font.constants";

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	cursor: pointer;
`;

export const Label = styled.label`
	${satoshi500}
	font-size: 1rem;
	color: ${colours.black};
	cursor: pointer;
`;

export const Checkbox = styled.input`
	appearance: none;
	margin: 0;
	width: 1rem;
	height: 1rem;
	border-radius: 0.25rem;
	border: 1px solid ${colours.greyDarker};
	background-color: ${colours.white};
	cursor: pointer;
	position: relative;

	&:checked {
		border-color: ${colours.black};
	}

	&:checked::after {
		content: "";
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 0.55rem;
		height: 0.55rem;
		background-color: ${colours.black};
	}
`;
